import React from "react";
import PropTypes from "prop-types";
import { Popover, Icon } from "../../common/UIComponents";
import Copyable from "../common/Copyable";

// Info icon + hover popover listing each participating order and its price type:
// FMP (first/default price) or SMP (second price applied), derived from the
// per-order transportation charges. The list is scrollable so a long set of
// consolidated orders stays usable, and each order number is copyable.
const OrderPriceTypePopover = ({ charges = [] }) => {
  const list = (charges || []).filter((c) => c && c.order_number);
  if (!list.length) return null;

  return (
    <Popover
      placement="bottom"
      trigger="hover"
      title={<span className="fontSize12 textBold">Orders — FMP / SMP</span>}
      content={
        <div
          style={{
            fontSize: 12,
            lineHeight: "22px",
            maxHeight: 240,
            overflowY: "auto",
            minWidth: 180,
            fontWeight: "normal",
          }}
        >
          {list.map((c, i) => {
            // Prefer the backend's explicit label (group_orders.applied_machine_pricing
            // = "FMP"/"SMP"). Fall back to is_smp_applied (transportation charge),
            // treating only boolean true / string "true" as SMP.
            const isSmp = c.applied_machine_pricing
              ? c.applied_machine_pricing === "SMP"
              : c.is_smp_applied === true || c.is_smp_applied === "true";
            return (
              <div
                key={i}
                style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16 }}
              >
                <span>
                  #{c.order_number}&nbsp;
                  <Copyable text={`${c.order_number}`} />
                </span>
                <span className={isSmp ? "textRed textBold" : "textBold"}>
                  {isSmp ? "SMP" : "FMP"}
                </span>
              </div>
            );
          })}
        </div>
      }
    >
      <Icon
        type="info-circle"
        style={{ fontSize: 14, color: "#8c8c8c", cursor: "pointer", display: "block" }}
      />
    </Popover>
  );
};

OrderPriceTypePopover.propTypes = {
  charges: PropTypes.array,
};

export default OrderPriceTypePopover;
